import { useRecoilState } from "recoil";
import { despesaPessoal } from "../atom";

const useDespesaPessoalState = () => {
    return useRecoilState(despesaPessoal);
};

export default useDespesaPessoalState;